import { EditOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import TickMark from "../../../../assets/icons/tickMark.svg";
import CrossMark from "../../../../assets/icons/crossIcon.svg";

interface TestimonialProps {
  title: string;
  updateTitle?: (sectionId: string, newTitle: string) => void;
  isForSharing: boolean;
  testimonialData?: any;
  setTestimonialData?: any;
  sectionVisibility?: any;
  setSectionVisibility?: any;
  primaryColor?: string;
  accentColor?: string;
  canWrite?: boolean;
  canDelete?: boolean;
  previousTestMenialData?: any;
  setPreviousTestMenialData?: any;
}

const TestimonialSection: React.FC<TestimonialProps> = ({
  title,
  testimonialData,
  setTestimonialData,
  sectionVisibility,
  setSectionVisibility,
  primaryColor,
  accentColor,
  isForSharing,
  canWrite = false,
  canDelete = false,
  previousTestMenialData,
  setPreviousTestMenialData,
}) => {
  const [editHeading, setEditHeading] = useState(false);
  const [editBody, setEditBody] = useState<number | null>(null);
  const quoteIcon = `https://afp-crm-qa.s3.us-east-1.amazonaws.com/Camapaign-Landing-Pages-Assets/quote-icon.svg`;

  return (
    <div
      id="who-we-are"
      className="collapsible-section"
      style={{
        padding: "20px 60px",
        backgroundColor: primaryColor,
        background: primaryColor,
        position: "relative",
      }}
    >
      {!isForSharing && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: "45px",
          }}
          className={
            sectionVisibility?.["partner-success-metrics"] && !isForSharing
              ? "section-header"
              : ""
          }
        >
          {sectionVisibility["testimonials"] && (
            <h3
              style={{
                fontSize: "30px",
                fontWeight: 500,
                border: "none",
                background: "transparent",
                margin: 0,
                color: "#fff",
                wordBreak: "break-word",
              }}
            >
              {testimonialData?.title || "Testimonials"}
            </h3>
          )}

          <button
            onClick={() => {
              if (setSectionVisibility) {
                setSectionVisibility((prev: any) => ({
                  ...prev,
                  testimonials: !prev["testimonials"],
                }));
              }
            }}
            className={
              sectionVisibility?.["partner-success-metrics"]
                ? "toggle-section-button"
                : ""
            }
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              backgroundColor: "#fff",
              color: canWrite ? "#000000" : "rgba(0, 0, 0, 0.3)",
              boxShadow: "0 0 8px rgba(0,0,0,0.3)",
              padding: "6px 24px",
              border: "none",
              cursor: canWrite ? "pointer" : "not-allowed",
              width: "147px",
              height: "42px",
              borderRadius: "8px",
              fontSize: "15px",
              fontFamily: "Roboto, sans-serif",
            }}
            disabled={!canWrite}
          >
            {sectionVisibility?.["testimonials"]
              ? "Show Section"
              : "Hide Section"}{" "}
          </button>
        </div>
      )}
      {!sectionVisibility?.["testimonials"] && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
            justifyContent: "center",
            height: "auto",
            padding: "0px 30px",
          }}
          className="who-we-are-section"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
            className="who-we-are-section-heading"
          >
            {editHeading && !isForSharing ? (
              <input
                type="text"
                value={testimonialData?.title}
                onChange={(e) => {
                  setTestimonialData((prev: any) => ({
                    ...prev,
                    title: e.target.value,
                  }));
                }}
                onBlur={() => setEditHeading(false)}
                autoFocus
                style={{
                  fontSize: "30px",
                  color: "#fff",
                  backgroundColor: "transparent",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  fontWeight: "500",
                  outline: "none",
                  fontFamily: "Roboto, sans-serif",
                }}
                disabled={!canWrite}
                maxLength={40}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                <h3
                  style={{
                    fontSize: "30px",
                    margin: 0,
                    fontWeight: "500",
                    letterSpacing: "-0.5px",
                    color: "#fff",
                    width: "auto",
                    maxWidth: "750px",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    cursor: "default",
                  }}
                >
                  {title}
                </h3>
                {!isForSharing && (
                  <button
                    onClick={() => setEditHeading(true)}
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      cursor: canWrite ? "pointer" : "not-allowed",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "50%",
                      padding: "4px",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    disabled={!canWrite}
                  >
                    <EditOutlined fontSize="small" />
                  </button>
                )}
              </div>
            )}
          </div>
          {(isForSharing
            ? testimonialData?.testimonials?.some(
                (t: any) =>
                  t.author?.trim() ||
                  t.designation?.trim() ||
                  t.feedback?.trim()
              )
            : testimonialData?.testimonials?.length > 0) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                overflowX: "auto",
                justifyContent: "center",
                width: "100%",
                boxSizing: "border-box",
              }}
              className="who-we-are-section-cards"
            >
              {(isForSharing
                ? testimonialData.testimonials.filter(
                    (t: any) =>
                      t.author?.trim() ||
                      t.designation?.trim() ||
                      t.feedback?.trim()
                  )
                : testimonialData.testimonials
              ).map((testimonial: any, index: number) => (
                <div
                  key={index}
                  style={{
                    padding: "20px",
                    background: "#fff",
                    borderRadius: "12px",
                    width: "300px",
                    minHeight: "450px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    position: "relative",
                  }}
                  className="who-we-are-section-card"
                >
                  {editBody === index && !isForSharing ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          display: "flex",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={TickMark}
                          alt="Save"
                          onClick={() => {
                            setEditBody(null);
                            setPreviousTestMenialData(testimonialData);
                          }}
                          style={{
                            cursor: "pointer",
                            width: "32px",
                            height: "32px",
                          }}
                        />
                        <img
                          src={CrossMark}
                          alt="Clear"
                          onClick={() => {
                            const updated = [...testimonialData.testimonials];
                            updated[index] = {
                              author:
                                previousTestMenialData?.testimonials[index]
                                  ?.author || "",
                              designation:
                                previousTestMenialData?.testimonials[index]
                                  ?.designation || "",
                              feedback:
                                previousTestMenialData?.testimonials[index]
                                  ?.feedback || "",
                            };
                            setTestimonialData((prev: any) => ({
                              ...prev,
                              testimonials: updated,
                            }));
                            setEditBody(null);
                          }}
                          style={{
                            cursor: "pointer",
                            width: "32px",
                            height: "32px",
                          }}
                        />
                      </div>

                      <img
                        src={quoteIcon}
                        alt="quotes"
                        style={{
                          width: "70px",
                          height: "60px",
                          marginTop: "20px",
                          marginBottom: "10px",
                        }}
                      />

                      <textarea
                        value={testimonial.feedback}
                        onChange={(e) => {
                          const updated = [...testimonialData.testimonials];
                          updated[index] = {
                            ...updated[index],
                            feedback: e.target.value,
                          };
                          setTestimonialData((prev: any) => ({
                            ...prev,
                            testimonials: updated,
                          }));
                        }}
                        autoFocus
                        onFocus={(e) => e.target.select()}
                        style={{
                          maxWidth: "100%",
                          width: "270px",
                          height: "140px",
                          border: "2px solid #BDBDBD",
                          borderRadius: "6px",
                          fontSize: "16px",
                          padding: "10px",
                          marginBottom: "12px",
                          outline: "none",
                          cursor:
                            canWrite || isForSharing ? "text" : "not-allowed",
                        }}
                        maxLength={300}
                        disabled={!canWrite}
                      />
                      <div
                        style={{
                          borderBottom: "1px solid #212529",
                          marginBottom: "30px",
                        }}
                      />

                      <input
                        type="text"
                        placeholder="Enter Name"
                        value={testimonial.author}
                        onFocus={(e) => e.target.select()}
                        onChange={(e) => {
                          const updated = [...testimonialData.testimonials];
                          updated[index] = {
                            ...updated[index],
                            author: e.target.value,
                          };
                          setTestimonialData((prev: any) => ({
                            ...prev,
                            testimonials: updated,
                          }));
                        }}
                        style={{
                          fontSize: "18px",
                          maxWidth: "100%",
                          width: "290px",
                          marginBottom: "8px",
                          border: "none",
                          borderBottom: "1px solid #ccc",
                          outline: "none",
                          padding: "6px 4px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        maxLength={40}
                        disabled={!canWrite}
                      />

                      <input
                        type="text"
                        placeholder="Designation"
                        value={testimonial.designation}
                        onFocus={(e) => e.target.select()}
                        onChange={(e) => {
                          const updated = [...testimonialData.testimonials];
                          updated[index] = {
                            ...updated[index],
                            designation: e.target.value,
                          };
                          setTestimonialData((prev: any) => ({
                            ...prev,
                            testimonials: updated,
                          }));
                        }}
                        style={{
                          fontSize: "16px",
                          maxWidth: "100%",
                          width: "290px",
                          border: "none",
                          borderBottom: "1px solid #ccc",
                          outline: "none",
                          padding: "6px 4px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        maxLength={75}
                        disabled={!canWrite}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "290px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "20px",
                        }}
                      >
                        {!isForSharing && (
                          <button
                            onClick={() => setEditBody(index)}
                            style={{
                              background: "#fff",
                              border: "1px solid #ccc",
                              cursor: canWrite ? "pointer" : "not-allowed",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "50%",
                              padding: "4px",
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              fontFamily: "Roboto, sans-serif",
                            }}
                            disabled={!canWrite}
                          >
                            <EditOutlined fontSize="small" />
                          </button>
                        )}
                        <img
                          src={quoteIcon}
                          alt="quotes"
                          style={{
                            width: "70px",
                            height: "60px",
                            marginTop: "20px",
                          }}
                        />

                        <p
                          style={{
                            fontSize: "16px",
                            lineHeight: "1.6",
                            marginBottom: "16px",
                            letterSpacing: "-0.05px",
                            fontWeight: "300",
                            width: "auto",
                            maxWidth: "280px",
                          }}
                          title={testimonial.feedback}
                        >
                          {testimonial.feedback}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            borderBottom: "1px solid #212529",
                            marginBottom: "20px",
                          }}
                        />
                        <h3
                          style={{
                            fontSize: "18px",
                            margin: 0,
                            fontWeight: 600,
                            color: "#212529",
                            width: "auto",
                            maxWidth: "290px",
                            letterSpacing: "-0.05px",
                            marginBottom: "10px",
                            cursor: "default",
                          }}
                          title={testimonial.author}
                        >
                          {testimonial.author}
                        </h3>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            color: "#666",
                            fontWeight: "400",
                            letterSpacing: "-0.05px",
                            marginTop: "10px",
                            width: "auto",
                            maxWidth: "290px",
                            marginBottom: "10px",
                            cursor: "default",
                          }}
                          title={testimonial.designation}
                        >
                          {testimonial.designation}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TestimonialSection;
